
<div class = "text-center">
    <strong>
        {{msg|translate}}
    </strong>
</div>
